import React from 'react';
import { Link } from 'react-router-dom';

const TestsCard = (props) => {
	const { test } = props;
	return (
		<div className="test-card card mb-4 box-shadow">
			<div className="card-body d-flex flex-column">

				<p className="text-primary">
					<strong>{test.subject + ': '}</strong>
					<em>{test.professor}</em>
				</p>

				<h5 className="card-title">
					<span>{test.class}</span>
					<em style={{fontSize: '0.9em'}} >{`, ${test.day}.${test.month}.${test.year}`}</em>
				</h5>

				<p className="card-text"><span className="index-span" >{test.nThInYear && `[${test.nThInYear}.] `}</span>{test.description}</p>

				<Link to={`/test/${test.id}`} className="btn btn-outline-primary btn-block" >Poglej</Link>
			</div>
			<img src={test.images[0]} alt="" className="card-img-right" />
		</div>
	)
}

export default TestsCard
